module.exports = __webpack_public_path__ + "img/icon-buy-eth-eliw.7551a462.svg";